// المسار: src/Reviews.js
import React from 'react';

// الآن نستقبل قائمة الآراء (reviewsList) من الخارج
const Reviews = ({ darkMode, reviewsList }) => {
  return (
    <div style={{ margin: '40px 0' }}>
      <h3 style={{ textAlign: 'center', color: darkMode ? 'white' : '#1e3a8a', fontSize: '24px', marginBottom: '20px' }}>
        ⭐ ماذا يقول عملاؤنا؟
      </h3>
      
      {reviewsList.length === 0 ? (
        <p style={{textAlign: 'center', opacity: 0.6}}>لا توجد آراء بعد.</p>
      ) : (
        <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', justifyContent: 'center' }}>
          {reviewsList.map((r) => (
            <div key={r.id} style={{
              background: darkMode ? '#334155' : 'white',
              padding: '20px', borderRadius: '15px',
              boxShadow: '0 4px 10px rgba(0,0,0,0.05)',
              width: '260px',
              color: darkMode ? 'white' : '#333',
              borderTop: '4px solid #fbbf24',
              transition: 'transform 0.3s'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                <span style={{ fontWeight: 'bold' }}>{r.name}</span>
                <span style={{ color: '#fbbf24', fontSize: '14px' }}>{"⭐".repeat(r.rating)}</span>
              </div>
              <p style={{ fontStyle: 'italic', margin: '10px 0', lineHeight: '1.5', opacity: 0.8, fontSize: '14px' }}>
                "{r.comment}"
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Reviews;